import * as React from 'react';
import { AddOn, AddOnCategory, AddOnCategoryId } from './types';
import AddOnsList from './add-ons-list';
import AddOnsFilter from './add-ons-filter';
import { l } from '../localize';

type AddOnsProps = {
	items: AddOn[];
	categories: AddOnCategory[];
};

const itemsPerPage = 12;

const AddOns: React.FC<AddOnsProps> = ({ items, categories = [] }) => {
	const [filterBy, setFilterBy] = React.useState<AddOnCategoryId | false>(
		false,
	);
	const [pagesVisible, setPagesVisible] = React.useState<number>(1);

	const itemsInCategory = items.filter(
		item =>
			filterBy === false || (item.category && item.category.id === filterBy),
	);
	const itemsOnPage = itemsInCategory.slice(
		0,
		itemsPerPage * pagesVisible,
	);
	const morePages = itemsOnPage < itemsInCategory;

	return (
		<div>
			<AddOnsFilter
				categories={categories}
				filterBy={filterBy}
				onChangeFilter={setFilterBy}
			/>
			<AddOnsList items={itemsOnPage} />
			{morePages && (
				<button
					className="load-more"
					onClick={() => {
						setPagesVisible(pagesVisible + 1);
					}}
				>
					{l('show-more')}
				</button>
			)}
		</div>
	);
};

export default AddOns;
